import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchSupplyManagerOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchSupplyManagerOptionsQuery = { __typename?: 'Query', repairRequestSupplyManagers: { __typename?: 'WorkOrdersRepairRequestSupplyManagerGrapqhlConnection', edges: Array<{ __typename?: 'WorkOrdersRepairRequestSupplyManagerGrapqhlEdge', node: { __typename?: 'RepairRequestSupplyManager', email: string } }>, pageInfo: { __typename?: 'WorkOrdersPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export const FetchSupplyManagerOptionsDocument = gql`
    query FetchSupplyManagerOptions {
  repairRequestSupplyManagers {
    edges {
      node {
        email
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSupplyManagerOptionsGQL extends Apollo.Query<FetchSupplyManagerOptionsQuery, FetchSupplyManagerOptionsQueryVariables> {
    override document = FetchSupplyManagerOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }